import React, { useState, useEffect } from "react";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

const ModalAddType = ({ isOpen, onClose, modelId, onSave, isEmbedded = false }) => {
  const [typeName, setTypeName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedModelId, setSelectedModelId] = useState(modelId || ""); // Używamy modelId, jeśli istnieje
  const [models, setModels] = useState([]); // Lista dostępnych modeli
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    console.log("Props modelId:", modelId);
    console.log("Initial selectedModelId:", selectedModelId);
  }, [modelId, selectedModelId]);

  useEffect(() => {
    if (modelId) {
      console.log("Synchronizing modelId to selectedModelId:", modelId);
      setSelectedModelId(modelId); // Aktualizuj stan, gdy modelId jest dostępny
    }
  }, [modelId]);

  // Pobierz listę modeli, jeśli modelId nie jest przekazany
  useEffect(() => {
    if (!modelId && isOpen) {
      fetch(`${API_BASE_URL}/models/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Błąd: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => setModels(data))
        .catch((error) => {
          console.error("Błąd podczas pobierania modeli:", error.message);
          alert("Nie udało się załadować listy modeli.");
        });
    }
  }, [modelId, isOpen]);

  const handleSave = async () => {
    if (!typeName) {
      alert("Name is required");
      return;
    }

    if (!selectedModelId) {
      alert("Please select a model.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/types/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: typeName,
          description,
          model: selectedModelId, // Wybrany model ID
        }),
      });

      if (!response.ok) {
        throw new Error(`Błąd: ${response.status}`);
      }

      const savedType = await response.json();
      console.log("Nowy typ zapisany:", savedType);
      setTypeName("");
      setDescription("");
      setSelectedModelId(modelId || ""); // Reset but keep modelId if it was provided

      onSave(savedType.id);
      onClose(); // Zamknięcie modala po zapisaniu
    } catch (error) {
      console.error("Błąd podczas zapisywania typu:", error.message);
      alert("Nie udało się zapisać typu. Spróbuj ponownie.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setTypeName("");
    setDescription("");
    setSelectedModelId(modelId || ""); // Reset but keep modelId if it was provided
    onClose();
  };

  if (!isOpen) return null;

  // Form content to be reused in both embedded and modal views
  const formContent = (
    <>
      {/* Warunkowe wyświetlanie pola wyboru modelu */}
      {!modelId && (
        <div className="mb-4">
          <label className="block text-sm font-medium text-graphite-700">Choose model</label>
          <select
            value={selectedModelId}
            onChange={(e) => setSelectedModelId(e.target.value)}
            className="w-full border rounded px-3 py-2 text-graphite-700"
          >
            <option value="">-- Choose model --</option>
            {models.map((model) => (
              <option key={model.id} value={model.id}>
                {model.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-graphite-700">Type</label>
        <input
          type="text"
          value={typeName}
          onChange={(e) => setTypeName(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
          placeholder="Name"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
          placeholder="Description"
          rows="3"
        ></textarea>
      </div>
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleCancel}
          className="px-4 py-2  border border-steel-300 text-graphite-700 font-medium rounded-full hover:bg-steel-100 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2  border border-brand-500 bg-brand-500 font-medium text-white rounded-full hover:bg-brand-600 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </button>
      </div>
    </>
  );

  // When embedded in the toggle menu
  if (isEmbedded) {
    return (
      <div>
        <h3 className="text-lg font-semibold mb-4">Add Type</h3>
        {formContent}
      </div>
    );
  }

  // When used as a standalone modal
  return (
    <div className="fixed inset-0 bg-graphite-950/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Add Type</h2>
        {formContent}
      </div>
    </div>
  );
};

export default ModalAddType;